// extracted by mini-css-extract-plugin
module.exports = {"Movies":"Movies_Movies__3rYrp"};